import { Box } from '@chakra-ui/react'
import { firstObVisitField } from '@hb/shared'
import { FormElement } from '../../../../components/forms'
import { SectionLabel } from '../../SectionLabel'

export const FirstObVisitInput = () => (
  <Box w="100%" data-child-name="data.firstObVisit" px={5} py="14px">
    <SectionLabel>First OB Visit</SectionLabel>
    <FormElement root showName={false} field={firstObVisitField} name="data.firstObVisit" />
  </Box>
)
